<div id="nav-bar-left">
  <div id="title">

    <svg-icon class="justify-content-center" [src]="'./icon/logo-vibradata-white.svg'"></svg-icon>

    <svg *ngIf="!toggleSelect" (click)="toggleSelect = true; $event.stopPropagation()" id="hamburger" width="18"
      height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.25 13.751C0.25 13.0606 0.809644 12.501 1.5 12.501H16.5C17.1904 12.501 17.75 13.0606 17.75 13.751C17.75 14.4413 17.1904 15.001 16.5 15.001H1.5C0.809645 15.001 0.25 14.4413 0.25 13.751Z"
        fill="#FDFDFD" />
      <path
        d="M0.25 1.25098C0.25 0.560621 0.809644 0.000976562 1.5 0.000976562H16.5C17.1904 0.000976562 17.75 0.560621 17.75 1.25098C17.75 1.94133 17.1904 2.50098 16.5 2.50098H1.5C0.809645 2.50098 0.25 1.94133 0.25 1.25098Z"
        fill="#FDFDFD" />
      <path
        d="M0.25 7.50098C0.25 6.81062 0.809644 6.25098 1.5 6.25098H16.5C17.1904 6.25098 17.75 6.81062 17.75 7.50098C17.75 8.19133 17.1904 8.75098 16.5 8.75098H1.5C0.809645 8.75098 0.25 8.19133 0.25 7.50098Z"
        fill="#FDFDFD" />
    </svg>

    <svg *ngIf="toggleSelect" (click)="toggleSelect = false; $event.stopPropagation()" id="hamburger" width="18"
      height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M0.591709 1.09171C1.04732 0.636097 1.78601 0.636097 2.24162 1.09171L9 7.85008L15.7584 1.09171C16.214 0.636097 16.9527 0.636097 17.4083 1.09171C17.8639 1.54732 17.8639 2.28601 17.4083 2.74162L10.6499 9.5L17.4083 16.2584C17.8639 16.714 17.8639 17.4527 17.4083 17.9083C16.9527 18.3639 16.214 18.3639 15.7584 17.9083L9 11.1499L2.24162 17.9083C1.78601 18.3639 1.04732 18.3639 0.591709 17.9083C0.136097 17.4527 0.136097 16.714 0.591709 16.2584L7.35008 9.5L0.591709 2.74162C0.136097 2.28601 0.136097 1.54732 0.591709 1.09171Z"
        fill="#FDFDFD" />
    </svg>
  </div>

  <div class="menu no-select" [ngClass]="{ close: !toggleSelect, open: toggleSelect }">
    <div class="items">
      <div class="item p-4 mb-2" (click)="goToMapWithControlPoints()"
        [ngClass]="{ active: currentMenu === menuOptions.CONTROL_POINT  }">
         <svg-icon [src]="'./icon/controlPoint-white.svg'"></svg-icon>

        <div class="item-name">{{ 'NAVIGATION.MEASUREMENT_POINT' | translate }}</div>


      </div>

      <div class="item p-4 mb-2" (click)="goToMapWithEvents()"
        [ngClass]="{ active: currentMenu === menuOptions.EVENT}">
        <svg-icon [src]="'./icon/event.svg'"></svg-icon>

        <div class="item-name">{{ 'NAVIGATION.EVENTS' | translate }}</div>
      </div>

      <div class="item p-4 mb-2" (click)="openDevicePage()"
        [ngClass]="{ active: currentMenu === menuOptions.DEVICES }">
      <svg-icon [src]="'./icon/device-white.svg'"></svg-icon>
        <div class="item-name">{{ 'NAVIGATION.DEVICES' | translate }}</div>
      </div>
      <div class="item p-4 mb-2" (click)="openMonitoringPage()"
        [ngClass]="{ active: currentMenu === menuOptions.MONITORING  }">
          <svg-icon [src]="'./icon/monitoring.svg'"></svg-icon>
        <div class="item-name">{{ 'NAVIGATION.MONITORING' | translate }}</div>


      </div>
      <div class="item p-4 mb-2" (click)="openTimelinePage()"
        [ngClass]="{ active: currentMenu === menuOptions.TIMELINE  }">
          <svg-icon [src]="'./icon/time-line.svg'"></svg-icon>
        <div class="item-name">{{ 'TIMELINE.TITLE' | translate }}</div>
      </div>
    </div>

    <div class="divider"></div>

    <div class="menu-profil-medium">
      <div>
        {{ keycloakService.fullName}}
      </div>

      <button>
        <svg width="14" height="16" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M6.9177 1.60714C5.27112 1.60714 3.9363 2.94196 3.9363 4.58854C3.9363 6.23512 5.27112 7.56994 6.9177 7.56994C8.56428 7.56994 9.89909 6.23512 9.89909 4.58854C9.89909 2.94196 8.56428 1.60714 6.9177 1.60714ZM9.81538 8.14655C10.8473 7.30516 11.5062 6.0238 11.5062 4.58854C11.5062 2.05436 9.45188 0 6.9177 0C4.38351 0 2.32916 2.05436 2.32916 4.58854C2.32916 6.02381 2.98813 7.30516 4.02002 8.14656C1.48956 9.23483 0 11.7066 0 14.1964C0 14.6402 0.359771 15 0.803571 15C1.24737 15 1.60714 14.6402 1.60714 14.1964C1.60714 11.7028 3.60198 9.17708 6.9177 9.17708C10.2334 9.17708 12.2284 11.7028 12.2284 14.1964C12.2284 14.6402 12.5881 15 13.0319 15C13.4757 15 13.8355 14.6402 13.8355 14.1964C13.8355 11.7066 12.3459 9.23482 9.81538 8.14655Z"
            fill="#121212" />
        </svg>

        <span>{{ 'BUTTONS.PROFILE' | translate }}</span>
      </button>
      <button>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.75001 3.20424C1.13583 4.00332 0.672714 4.92433 0.403055 5.92487H4.47063L1.75001 3.20424Z"
            fill="#474B8F" />
          <path d="M15.502 5.92484C15.2323 4.92433 14.7692 4.00332 14.1551 3.20424L11.4345 5.92484H15.502Z"
            fill="#474B8F" />
          <path d="M0.403055 10.0046C0.672744 11.0051 1.13586 11.9261 1.75001 12.7251L4.47054 10.0046H0.403055Z"
            fill="#474B8F" />
          <path d="M12.7132 1.76198C11.9141 1.1478 10.9932 0.68469 9.99263 0.415V4.48255L12.7132 1.76198Z"
            fill="#474B8F" />
          <path d="M3.1923 14.167C3.99138 14.7811 4.91239 15.2443 5.9129 15.5139V11.4464L3.1923 14.167Z"
            fill="#474B8F" />
          <path d="M5.91287 0.415C4.91236 0.68469 3.99135 1.1478 3.1923 1.76195L5.91287 4.48252V0.415Z"
            fill="#474B8F" />
          <path d="M9.99263 15.5139C10.9931 15.2443 11.9141 14.7811 12.7132 14.167L9.99263 11.4464V15.5139Z"
            fill="#474B8F" />
          <path d="M11.4345 10.0046L14.1551 12.7252C14.7692 11.9261 15.2323 11.0051 15.502 10.0046H11.4345Z"
            fill="#474B8F" />
          <path
            d="M15.7056 6.94497H8.9728L8.97276 0.212136C8.63891 0.168674 8.29854 0.14595 7.95289 0.14595C7.60718 0.14595 7.26688 0.168674 6.93305 0.212136V6.94491L0.200218 6.94494C0.156756 7.2788 0.134032 7.61916 0.134032 7.96481C0.134032 8.31052 0.156756 8.65082 0.200218 8.98465H6.93299L6.93302 15.7175C7.26688 15.7609 7.60718 15.7837 7.95289 15.7837C8.29854 15.7837 8.6389 15.761 8.97273 15.7175V8.98471L15.7056 8.98468C15.749 8.65082 15.7718 8.31052 15.7718 7.96481C15.7718 7.61916 15.749 7.2788 15.7056 6.94497Z"
            fill="#D7535B" />
          <path
            d="M9.99286 10.0048L13.4819 13.4939C13.6424 13.3334 13.7955 13.1657 13.9415 12.9919L10.9544 10.0048L9.99286 10.0048Z"
            fill="#D7535B" />
          <path
            d="M5.91344 10.0048L2.42437 13.4938C2.58478 13.6543 2.75248 13.8073 2.92633 13.9534L5.91344 10.9662V10.0048Z"
            fill="#D7535B" />
          <path
            d="M5.91335 5.92542L2.4243 2.43629C2.26383 2.59669 2.11075 2.7644 1.9647 2.93825L4.95184 5.92539L5.91335 5.92542Z"
            fill="#D7535B" />
          <path
            d="M9.99286 5.9253L13.4819 2.43619C13.3215 2.27572 13.1538 2.12264 12.98 1.97662L9.99286 4.96376V5.9253Z"
            fill="#D7535B" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M8 15.4476C12.1132 15.4476 15.4476 12.1132 15.4476 8C15.4476 3.88678 12.1132 0.552354 8 0.552354C3.88678 0.552354 0.552353 3.88678 0.552353 8C0.552353 12.1132 3.88678 15.4476 8 15.4476ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
            fill="#FDFDFD" />
        </svg>
        <span>{{ 'BUTTONS.LANGUAGE' | translate }}</span>

        <div class="fa-solid fa-caret-down"></div>
      </button> <button (click)="keycloakService.logout()">
        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" stroke="black" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M0.695739 0.676741C1.14121 0.243431 1.74541 0 2.3754 0H8.00004C8.63003 0 9.23423 0.243431 9.6797 0.676741C10.1252 1.11005 10.3754 1.69774 10.3754 2.31054V3.87369C10.3754 4.28646 10.0314 4.62107 9.60708 4.62107C9.18272 4.62107 8.83871 4.28646 8.83871 3.87369V2.31054C8.83871 2.09418 8.75035 1.88669 8.59307 1.7337C8.43579 1.58071 8.22247 1.49477 8.00004 1.49477H2.3754C2.15297 1.49477 1.93965 1.58071 1.78237 1.7337C1.62509 1.88669 1.53673 2.09418 1.53673 2.31054V11.6895C1.53673 11.9058 1.62509 12.1133 1.78237 12.2663C1.93965 12.4193 2.15297 12.5052 2.3754 12.5052H8.00004C8.22247 12.5052 8.43579 12.4193 8.59307 12.2663C8.75035 12.1133 8.83871 11.9058 8.83871 11.6895V10.1263C8.83871 9.71354 9.18272 9.37893 9.60708 9.37893C10.0314 9.37893 10.3754 9.71354 10.3754 10.1263V11.6895C10.3754 12.3023 10.1252 12.8899 9.6797 13.3233C9.23423 13.7566 8.63003 14 8.00004 14H2.3754C1.74541 14 1.14121 13.7566 0.695739 13.3233C0.250265 12.8899 0 12.3023 0 11.6895V2.31054C0 1.69774 0.250265 1.11005 0.695739 0.676741Z"
            fill="#FDFDFD" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M12.2778 4.1268C12.5778 3.83493 13.0643 3.83493 13.3644 4.1268L15.775 6.47153C16.075 6.7634 16.075 7.23662 15.775 7.52849L13.3644 9.87322C13.0643 10.1651 12.5778 10.1651 12.2778 9.87322C11.9777 9.58135 11.9777 9.10813 12.2778 8.81626L13.3766 7.74739H5.58941C5.16505 7.74739 4.82104 7.41278 4.82104 7.00001C4.82104 6.58724 5.16505 6.25263 5.58941 6.25263H13.3766L12.2778 5.18376C11.9777 4.89189 11.9777 4.41867 12.2778 4.1268Z"
            fill="#FDFDFD" />
        </svg>
        <span>{{ 'BUTTONS.LOGOUT' | translate }}</span>
      </button>
    </div>

    <div class="menu-profil-small">
      <div>
        {{ keycloakService.fullName}}
      </div>

      <button>
        <svg width="14" height="16" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M6.9177 1.60714C5.27112 1.60714 3.9363 2.94196 3.9363 4.58854C3.9363 6.23512 5.27112 7.56994 6.9177 7.56994C8.56428 7.56994 9.89909 6.23512 9.89909 4.58854C9.89909 2.94196 8.56428 1.60714 6.9177 1.60714ZM9.81538 8.14655C10.8473 7.30516 11.5062 6.0238 11.5062 4.58854C11.5062 2.05436 9.45188 0 6.9177 0C4.38351 0 2.32916 2.05436 2.32916 4.58854C2.32916 6.02381 2.98813 7.30516 4.02002 8.14656C1.48956 9.23483 0 11.7066 0 14.1964C0 14.6402 0.359771 15 0.803571 15C1.24737 15 1.60714 14.6402 1.60714 14.1964C1.60714 11.7028 3.60198 9.17708 6.9177 9.17708C10.2334 9.17708 12.2284 11.7028 12.2284 14.1964C12.2284 14.6402 12.5881 15 13.0319 15C13.4757 15 13.8355 14.6402 13.8355 14.1964C13.8355 11.7066 12.3459 9.23482 9.81538 8.14655Z"
            fill="#121212" />
        </svg>

        <span>{{ 'BUTTONS.PROFILE' | translate }}</span>
      </button>
      <button>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.75001 3.20424C1.13583 4.00332 0.672714 4.92433 0.403055 5.92487H4.47063L1.75001 3.20424Z"
            fill="#474B8F" />
          <path d="M15.502 5.92484C15.2323 4.92433 14.7692 4.00332 14.1551 3.20424L11.4345 5.92484H15.502Z"
            fill="#474B8F" />
          <path d="M0.403055 10.0046C0.672744 11.0051 1.13586 11.9261 1.75001 12.7251L4.47054 10.0046H0.403055Z"
            fill="#474B8F" />
          <path d="M12.7132 1.76198C11.9141 1.1478 10.9932 0.68469 9.99263 0.415V4.48255L12.7132 1.76198Z"
            fill="#474B8F" />
          <path d="M3.1923 14.167C3.99138 14.7811 4.91239 15.2443 5.9129 15.5139V11.4464L3.1923 14.167Z"
            fill="#474B8F" />
          <path d="M5.91287 0.415C4.91236 0.68469 3.99135 1.1478 3.1923 1.76195L5.91287 4.48252V0.415Z"
            fill="#474B8F" />
          <path d="M9.99263 15.5139C10.9931 15.2443 11.9141 14.7811 12.7132 14.167L9.99263 11.4464V15.5139Z"
            fill="#474B8F" />
          <path d="M11.4345 10.0046L14.1551 12.7252C14.7692 11.9261 15.2323 11.0051 15.502 10.0046H11.4345Z"
            fill="#474B8F" />
          <path
            d="M15.7056 6.94497H8.9728L8.97276 0.212136C8.63891 0.168674 8.29854 0.14595 7.95289 0.14595C7.60718 0.14595 7.26688 0.168674 6.93305 0.212136V6.94491L0.200218 6.94494C0.156756 7.2788 0.134032 7.61916 0.134032 7.96481C0.134032 8.31052 0.156756 8.65082 0.200218 8.98465H6.93299L6.93302 15.7175C7.26688 15.7609 7.60718 15.7837 7.95289 15.7837C8.29854 15.7837 8.6389 15.761 8.97273 15.7175V8.98471L15.7056 8.98468C15.749 8.65082 15.7718 8.31052 15.7718 7.96481C15.7718 7.61916 15.749 7.2788 15.7056 6.94497Z"
            fill="#D7535B" />
          <path
            d="M9.99286 10.0048L13.4819 13.4939C13.6424 13.3334 13.7955 13.1657 13.9415 12.9919L10.9544 10.0048L9.99286 10.0048Z"
            fill="#D7535B" />
          <path
            d="M5.91344 10.0048L2.42437 13.4938C2.58478 13.6543 2.75248 13.8073 2.92633 13.9534L5.91344 10.9662V10.0048Z"
            fill="#D7535B" />
          <path
            d="M5.91335 5.92542L2.4243 2.43629C2.26383 2.59669 2.11075 2.7644 1.9647 2.93825L4.95184 5.92539L5.91335 5.92542Z"
            fill="#D7535B" />
          <path
            d="M9.99286 5.9253L13.4819 2.43619C13.3215 2.27572 13.1538 2.12264 12.98 1.97662L9.99286 4.96376V5.9253Z"
            fill="#D7535B" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M8 15.4476C12.1132 15.4476 15.4476 12.1132 15.4476 8C15.4476 3.88678 12.1132 0.552354 8 0.552354C3.88678 0.552354 0.552353 3.88678 0.552353 8C0.552353 12.1132 3.88678 15.4476 8 15.4476ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
            fill="#FDFDFD" />
        </svg>
        <span>{{ 'BUTTONS.LANGUAGE' | translate }}</span>
        <div class="fa-solid fa-caret-down"></div>
      </button>
      <button (click)="keycloakService.logout()">
        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" stroke="black" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M0.695739 0.676741C1.14121 0.243431 1.74541 0 2.3754 0H8.00004C8.63003 0 9.23423 0.243431 9.6797 0.676741C10.1252 1.11005 10.3754 1.69774 10.3754 2.31054V3.87369C10.3754 4.28646 10.0314 4.62107 9.60708 4.62107C9.18272 4.62107 8.83871 4.28646 8.83871 3.87369V2.31054C8.83871 2.09418 8.75035 1.88669 8.59307 1.7337C8.43579 1.58071 8.22247 1.49477 8.00004 1.49477H2.3754C2.15297 1.49477 1.93965 1.58071 1.78237 1.7337C1.62509 1.88669 1.53673 2.09418 1.53673 2.31054V11.6895C1.53673 11.9058 1.62509 12.1133 1.78237 12.2663C1.93965 12.4193 2.15297 12.5052 2.3754 12.5052H8.00004C8.22247 12.5052 8.43579 12.4193 8.59307 12.2663C8.75035 12.1133 8.83871 11.9058 8.83871 11.6895V10.1263C8.83871 9.71354 9.18272 9.37893 9.60708 9.37893C10.0314 9.37893 10.3754 9.71354 10.3754 10.1263V11.6895C10.3754 12.3023 10.1252 12.8899 9.6797 13.3233C9.23423 13.7566 8.63003 14 8.00004 14H2.3754C1.74541 14 1.14121 13.7566 0.695739 13.3233C0.250265 12.8899 0 12.3023 0 11.6895V2.31054C0 1.69774 0.250265 1.11005 0.695739 0.676741Z"
            fill="#FDFDFD" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M12.2778 4.1268C12.5778 3.83493 13.0643 3.83493 13.3644 4.1268L15.775 6.47153C16.075 6.7634 16.075 7.23662 15.775 7.52849L13.3644 9.87322C13.0643 10.1651 12.5778 10.1651 12.2778 9.87322C11.9777 9.58135 11.9777 9.10813 12.2778 8.81626L13.3766 7.74739H5.58941C5.16505 7.74739 4.82104 7.41278 4.82104 7.00001C4.82104 6.58724 5.16505 6.25263 5.58941 6.25263H13.3766L12.2778 5.18376C11.9777 4.89189 11.9777 4.41867 12.2778 4.1268Z"
            fill="#FDFDFD" />
        </svg>
        <span>{{ 'BUTTONS.LOGOUT' | translate }}</span>
      </button>
    </div>
  </div>

  <div id="footer">


    <div id="version">1.18.0</div>
  </div>
</div>